import React from 'react'
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const FallbackComponent = () => {
    return (
        <div>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: "9999",
                    backgroundColor: "#e3e2e6ed",
                }}
                open={true}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "1rem",
                    }}
                >
                    <CircularProgress
                        size={65}
                        sx={{
                            color: "#6d4cb1",
                            zIndex: 1,
                        }}
                    />
                    <Typography variant="p" sx={{ color: "#6d4cb1" }}>
                        Loading...
                    </Typography>
                </Box>
            </Backdrop>
        </div>
    )
}

export default FallbackComponent


